import React from 'react';
import {
  FaFileInvoiceDollar,
  FaShoppingCart,
  FaMoneyBillWave,
  FaUndoAlt,
} from 'react-icons/fa';

const configTipo = {
  factura: {
    icono: FaFileInvoiceDollar,
    color: 'text-color-primario',
    bgColor: 'bg-gray-100',
  },
  compra: {
    icono: FaShoppingCart,
    color: 'text-color-secundario',
    bgColor: 'bg-gray-100',
  },
  pago: {
    icono: FaMoneyBillWave,
    color: 'text-color-primario',
    bgColor: 'bg-gray-100',
  },
  nota_credito: {
    icono: FaUndoAlt,
    color: 'text-color-secundario',
    bgColor: 'bg-gray-100',
  },
};

const configEstado = {
  completada: {
    label: 'Completada',
    clase: 'bg-gray-100 text-color-primario',
  },
  pendiente: {
    label: 'Pendiente',
    clase: 'bg-gray-200 text-gray-600',
  },
  procesada: {
    label: 'Procesada',
    clase: 'bg-gray-100 text-color-secundario',
  },
};

const formatearHora = (fechaISO) => {
  const fecha = new Date(fechaISO);

  return fecha.toLocaleDateString('es-DO', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

const ActividadReciente = ({ transacciones = [], formatoMoneda }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 h-full">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-semibold text-gray-800">Actividad Reciente</h3>
        <span className="text-xs text-gray-400 bg-gray-100 px-3 py-1 rounded-full">
          Últimas {transacciones.length}
        </span>
      </div>

      {/* Lista de transacciones */}
      {transacciones.length === 0 ? (
        <div className="text-center py-8">
          <FaFileInvoiceDollar className="mx-auto text-gray-300 mb-2" size={32} />
          <p className="text-sm text-gray-400">No hay actividad reciente</p>
        </div>
      ) : (
        <div className="space-y-3">
          {transacciones.slice(0, 5).map((tx) => {
            const tipo = configTipo[tx.tipo] || configTipo.factura;
            const estado = configEstado[tx.estado] || configEstado.pendiente;
            const Icono = tipo.icono;

            return (
              <div
                key={tx.id}
                className="flex items-center gap-3 p-3 rounded-lg border border-gray-100 hover:bg-gray-50 transition-colors"
              >
                {/* Icono */}
                <div className={`w-9 h-9 ${tipo.bgColor} rounded-lg flex items-center justify-center flex-shrink-0`}>
                  <Icono className={`${tipo.color} text-sm`} />
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-medium text-gray-800 truncate">{tx.descripcion}</p>
                    <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full flex-shrink-0 ${estado.clase}`}>
                      {estado.label}
                    </span>
                  </div>
                  <p className="text-xs text-gray-400 truncate">{tx.entidad}</p>
                </div>

                {/* Monto y hora */}
                <div className="text-right flex-shrink-0">
                  <p className="text-sm font-semibold text-gray-800">
                    {formatoMoneda ? formatoMoneda(tx.monto) : `$${tx.monto.toLocaleString()}`}
                  </p>
                  <p className="text-[11px] text-gray-400">{formatearHora(tx.fecha)}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ActividadReciente;
